import type { PricingVersion } from './types';
import { isAttemptId, isPricingVersion, isRecord } from './validation';

export interface FunnelAttribution {
  opening_id?: string;
  pricing_catalog_version?: PricingVersion;
}

/** API/completion exposure omits unknown versions; start events explicitly send null. */
export function safeFunnelAttribution(value: unknown): FunnelAttribution {
  if (!isRecord(value)) return {};
  return {
    ...(isAttemptId(value.opening_id) ? { opening_id: value.opening_id } : {}),
    ...(isPricingVersion(value.pricing_catalog_version)
      ? { pricing_catalog_version: value.pricing_catalog_version }
      : {}),
  };
}
